import { dropZeroCents, formatAsCurrency, formatAsCurrencyOrZero } from '../../utils/priceTools'

export const rebatesPayoutMinimum = 1000
export const rebatesPayoutPercent = 75
export const rebatesPayoutFeePercent = 100 - rebatesPayoutPercent

export const getRebateBalanceAmounts = ({ rebateBalance }: { rebateBalance: number }) => {
  const isPayoutAvailable = rebateBalance >= rebatesPayoutMinimum
  const remainingUntilAvailable = Math.max(0, rebatesPayoutMinimum - rebateBalance)

  const maxPayoutAmount = rebateBalance * (rebatesPayoutPercent / 100)

  return {
    isPayoutAvailable: {
      value: isPayoutAvailable,
    },
    remaining: {
      value: remainingUntilAvailable,
      formatted: dropZeroCents(formatAsCurrencyOrZero({ amount: remainingUntilAvailable })),
    },
    balance: {
      value: rebateBalance,
      formatted: dropZeroCents(formatAsCurrencyOrZero({ amount: rebateBalance })),
    },
    percentage: {
      value: rebatesPayoutPercent,
      formatted: `%${rebatesPayoutPercent}`,
    },
    minRedeemable: {
      value: rebatesPayoutMinimum,
      formatted: formatAsCurrency({ amount: rebatesPayoutMinimum, fractionDigits: 0 }) || '$0',
    },
    maxRedeemable: {
      value: rebateBalance,
      formatted: formatAsCurrency({ amount: rebateBalance }) || '$0',
    },
    maxPayoutAmount: {
      value: maxPayoutAmount,
      formatted: dropZeroCents(formatAsCurrencyOrZero({ amount: maxPayoutAmount })),
    },
  }
}

export const getRedeemForCashAmounts = ({ balanceToRedeem }: { balanceToRedeem: number }) => {
  const payout = balanceToRedeem * (rebatesPayoutPercent / 100)

  return {
    balance: {
      value: balanceToRedeem,
      formatted: formatAsCurrency({ amount: balanceToRedeem, fractionDigits: 0 }) || '$0',
    },
    payout: {
      value: payout,
      formatted: formatAsCurrencyOrZero({ amount: payout }),
    },
  }
}
